import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/draw`;

class AllDrawServices {
  /**
   * @param {string} date - YYYY-MM-DD (today or past)
   * @param {string} gameType - '3min' | '5min'
   */
  async getDrawsByDate(date, gameType) {
    const url = `${API_ROUTE}/draws-by-date?date=${encodeURIComponent(date)}&gameType=${encodeURIComponent(gameType)}`;
    const response = await requestToken.get(url);
    return response;
  }
}

export default AllDrawServices;
